import { UserDTO } from './common/Dtos';
import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, Grid } from '@material-ui/core';
import { SDialogButton, SDialogTitle } from './common/BCommonComponents';

interface VerificaEmailDialogProps {
	open: boolean;
	onClose: (ex: string) => void;
	userDTO: UserDTO;
}

function VerificaEmailDialog(props: VerificaEmailDialogProps) {
	const { onClose, open } = props;
	const [user, setUser] = useState<UserDTO>(props.userDTO);

	useEffect(() => {
		setUser(props.userDTO);
	}, [open]);

	const handleConferma = () => {
		onClose('confirm');
	};
	const handleModifica = () => {
		onClose('edit');
	};
	return (
		<Dialog
			disableBackdropClick
			open={open}>
			<SDialogTitle className="pb-0" id="simple-dialog-title">VERIFICA EMAIL</SDialogTitle>
			<DialogContent>
				<Grid container spacing={0} className="w-100">
					<Grid item xs={12} className="px-2">
						Questo è l’indirizzo email associato alla tua utenza: <b>{user.email}</b>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions className="p-4">
				<SDialogButton className="float-right" onClick={handleModifica}>Modifica email</SDialogButton>
				<SDialogButton className="float-right" onClick={handleConferma}>Verifica email</SDialogButton>
			</DialogActions>
		</Dialog>
	);
}

export default VerificaEmailDialog;
